export default "__VITE_ASSET__76a0c7c7__"